import React from "react";
import Hero from "../components/Hero";
import TrustIntro from "../components/TrustIntro";
import Stats from "../components/Stats";
import TechStack from "../components/TechStack";
import Services from "../components/Services";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Industries from "../components/Industries";
import ClientsShowcase from "../components/ClientsShowcase";
import GCCFeature from "../components/GCCFeature";
import CTABanner from "../components/CTABanner";

export default function Home() {
  return (
    <>
      <Hero />
      <div id="below-hero" />
      <TrustIntro />
      <Stats />
      <TechStack />
      <Services />
      <WhyProspera />
      <HowWeWork />
      <Industries />
      <ClientsShowcase />
      <GCCFeature />
      <CTABanner />
    </>
  );
}
